/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useRef, useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { groupBy, range, result, update } from 'lodash';
import PaginationBox from './PaginationBox';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { TableHead } from './gridComponents/tableHead';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getSearchResult,
  getRebatePercentExportAll,
  setRebatePercentExportAll,
} from '../Store/action';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { exportAllPDF } from '../../../../SharedModules/pdfExport/exportAll';

export default function DisplayPercent() {
  const dispatch = useDispatch();
  const {
    isLoading,
    exportAllData,
    displayObj: {
      rebateProgramValue,
      searchResult,
      rangeType,
      fromQuarter,
      toQuarter,
      isAllManufacturersSelected,
      rebateProgrameName,
    },
    manufacturerList,
    manufacturerSelected,
  } = useSelector((state) => state?.sharedState?.RebatePercentOfSpendReducer);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramList?.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${rebateProgramNameValue?.rebateProgramCd} - ${
  //   rebateProgramNameValue?.shortDescr || ''
  // }`;

  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  const [exportAllClicked, setExportAllClicked] = React.useState(false);
  const [columnApi, setColumnApi] = React.useState(null);

  const [rows, setRows] = React.useState([]);
  const [filteredRows, setFilteredRow] = React.useState([]);

  const [groupData, setGroupData] = React.useState({});
  const [keys, setKeys] = React.useState([]);

  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(Object.keys(groupData).length).keys(),
  ]);

  const [count, setCount] = React.useState(1);
  const manufacturerWithData = `${keys[count - 1]}: ${
    manufacturerList.rebatePercentOfSpendMfgGridVO?.find(
      (item) => item.mfgId === keys[count - 1]
    )?.mfgName
  }`;

  const handleClick = (type, value) => {
    if (type === 'next') {
      setCount(count + 1);
    }

    if (type === 'previous') {
      setCount(count - 1);
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        setCount(paginationArray.length);
      } else {
        setCount(value);
      }
    }
  };
  
  const handleBlur = (value) => {
    const pageNumber = parseInt(value);
    let currentPage = 1;
    if (value === '' || isNaN(pageNumber) || pageNumber < 1) {
      currentPage = 1;
      setCount(1); 
    } else if (pageNumber > paginationArray.length) {
      currentPage = paginationArray.length;
      setCount(paginationArray.length);
    } else {
      setCount(pageNumber);
      currentPage = pageNumber;
    }
    return currentPage;
  };

  //   //Calling API and Passing dynamic values in the payload
  React.useEffect(() => {
    let updatedSearchResult = searchResult;
    updatedSearchResult = updatedSearchResult.map((item) => {
      const rebateLessOffset =
        (item.rebate_amt || 0) - (item.numOfRebateOffsetAmtUnits || 0);
      return {
        ...item,
        rebate_amt: item.rebate_amt ? item.rebate_amt : 0,
        numOfRebateOffsetAmtUnits: item.numOfRebateOffsetAmtUnits
          ? item.numOfRebateOffsetAmtUnits
          : 0,
        rebate_less_offset: rebateLessOffset,
      };
    });
    const groupedData = groupBy(updatedSearchResult, 'mfgId');
    setGroupData(groupedData);
    setPaginationArray([...Array(Object.keys(groupedData).length).keys()]);
    const keys = Object.keys(groupedData);
    keys.sort();
    setKeys(keys);
    // }
  }, [searchResult]);

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setExportAllClicked(true);

    dispatch(setRebatePercentExportAll([], 'noData'));
    dispatch(
      getRebatePercentExportAll({
        rebateProgramCode: rebateProgramValue,
        isAllMfg: isAllManufacturersSelected ? 1 : 0,
        fromQtr: fromQuarter,
        toQtr: toQuarter || fromQuarter,
        mfgIds: Object.keys(groupData),
        manufacturerList: manufacturerList,
      })
    );
  };
  const addPinnedRowData = () => {
    const exportAllDataObj = {};
    for (const key in exportAllData) {
      const data = JSON.parse(JSON.stringify(exportAllData[key]));
      const pinnedRow = {
        quarter: 'Grand Total :',
        // "qtr": "3Q2021",
        // "quarter": "3Q2021",
        rebate_amt: 0,
        reimbursement_amt: 0,
        numOfRebateOffsetAmtUnits: 0,
        rebate_less_offset: 0,
        bold: true,
      };
      for (let i = 0; i < data.length; i++) {
        pinnedRow.rebate_amt += data[i].rebate_amt;
        pinnedRow.reimbursement_amt += data[i].reimbursement_amt;
        pinnedRow.rebate_less_offset += data[i].rebate_less_offset;
        pinnedRow.numOfRebateOffsetAmtUnits +=
          data[i].numOfRebateOffsetAmtUnits;
      }
      data.push(pinnedRow);
      exportAllDataObj[key] = data;
    }

    return exportAllDataObj;
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  React.useEffect(() => {
    if (
      exportAllClicked &&
      Object.keys(exportAllData).length === Object.keys(groupData).length &&
      Object.keys(groupData).length > 0
    ) {
      const header = {
        reportName: 'Rebate Percent Of Spend',
        fileName: exportFileName,
      };
      const paginationArr = Object.keys(exportAllData).map((item) => item);
      paginationArr.sort();
      for (const key in exportAllData) {
        let mfgData = exportAllData[key];
        mfgData = mfgData?.map((item) => {
          const rebateLessOffset =
            item.rebate_amt - item.numOfRebateOffsetAmtUnits;
          const percent =
            item.reimbursement_amt === 0
              ? 0
              : `${(
                  (parseInt(rebateLessOffset) /
                    parseInt(item.reimbursement_amt)) *
                  100
                ).toFixed(2)} %`;
          return {
            ...item,
            rebate_less_offset: rebateLessOffset,
            percent,
          };
        });
        exportAllData[key] = mfgData;
      }

      // const modifiedData = JSON.parse(JSON.stringify());
      const allData = addPinnedRowData(exportAllData);
      const widths = TableHead.map((item, index) => '*');
      setExportAllClicked(false);
      exportAllPDF(
        header,
        allData,
        columnApi,
        userDefaults,
        {
          // pageSize: {
          //   width: 1250,
          //   height: 700,
          // },
          titleName: 'Manufacturer Name :',
          info: {
            fourthInfo: `${rebateProgramNameValue}`,
          },
        },
        paginationArr,
        widths,
        logInUser
      );
    }
  }, [exportAllData]);

  //   //Businness logic Fro search Result
  React.useEffect(() => {
    let updatedSearchResult = searchResult;
    updatedSearchResult = updatedSearchResult.map((item) => {
      const rebateLessOffset = item.rebate_amt - item.numOfRebateOffsetAmtUnits;
      return {
        ...item,
        rebate_less_offset: rebateLessOffset.toFixed(2),
      };
    });
    setRows(updatedSearchResult);
  }, [searchResult, count]);

  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  //   //Function to add all the records of the column
  const sum = (property) => {
    const displayedRows = filterApply
      ? filteredRows
      : groupData[keys[count - 1]];
    // const displayedRows = rows;
    if (property === 'checkLogNum') {
    } else {
      const data = displayedRows?.reduce((accumulator, object) => {
        return (
          accumulator + (object[property] ? parseFloat(object[property]) : null)
        );
      }, 0);
      return data ? parseFloat(data.toFixed(2)) : '0.00';
    }
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        quarter: 'Total :',
        rebate_amt: sum('rebate_amt'),
        numOfRebateOffsetAmtUnits: sum('numOfRebateOffsetAmtUnits'),
        rebate_less_offset: sum('rebate_less_offset'),
        reimbursement_amt: sum('reimbursement_amt'),
        percent: (
          (sum('rebate_less_offset') / sum('reimbursement_amt')) *
          100
        ).toFixed(2),
      });
    }
    return result;
  };
  //   //To pin the total at the bottom
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rows, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };

  const firstInfo = `Manufacturer : ${
    isAllManufacturersSelected ? 'ALL' : manufacturerWithData
  }`;
  const secondInfo = `Quarter Range : ${
    rangeType === 'all'
      ? 'ALL'
      : rangeType === 'drams'
      ? 'DRAMS Invoice Start Quarter'
      : rangeType === 'firstSummary'
      ? 'First Summary Report Quarter'
      : rangeType === 'selectedRange'
      ? `${fromQuarter}-${toQuarter}`
      : ''
  }`;
  const thirdInfo = rebateProgramNameValue;

  return (
    <>
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space devider-line pb-0">
          <Spinner load={isLoading} />

          {!fullScreenView && (
            <CustomSeparator
              parent1="Summary Reports"
              parent2="Display Rebate Percent Of Spend"
            />
          )}
          <div className="tBillPanel custom-check tabs-container bottom-pinned-bold">
            <div className="form-wrapper p-0 mt-2">
              <div className="mui-custom-form input-md field-xl">
                {!fullScreenView && (
                  <>
                    <div className="sub-radio no-margin">
                      <div className="row mb-3">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>

                      <div className="row mb-2">
                        <div className="col-6">
                          <TextField
                            label="Rebate Program : "
                            id="Rebate Program :"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="RebateProgram"
                            value={`${rebateProgramNameValue}`}
                            disabled
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <TextField
                            label="Quarter Option : "
                            id="Quarter Option : "
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="quarter"
                            disabled
                            value={
                              rangeType === 'all'
                                ? 'ALL'
                                : rangeType === 'drams'
                                ? 'DRAMS Invoice Start Quarter'
                                : rangeType === 'firstSummary'
                                ? 'First Summary Report Quarter'
                                : rangeType === 'selectedRange'
                                ? `${fromQuarter}-${toQuarter}`
                                : ''
                            }
                          />
                        </div>
                        <div className="col-6">
                          <TextField
                            label="Manufacturer : "
                            id="Manufacturer :"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="To"
                            disabled
                            value={
                              manufacturerSelected[0] === 'ALL'
                                ? 'ALL'
                                : manufacturerWithData
                            }
                            // value={manufacturerSelectedName}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <TableGrid
              columnDefs={TableHead}
              gridCall={onGridReady}
              rowData={
                Object.keys(groupData).length > 0
                  ? groupData[keys[count - 1]]?.map((item) => {
                      return {
                        ...item,
                        rebate_amt: item.rebate_amt,
                        numOfRebateOffsetAmtUnits:
                          item.numOfRebateOffsetAmtUnits,
                        reimbursement_amt: item.reimbursement_amt,
                        rebate_less_offset:
                          item.rebate_amt - item.numOfRebateOffsetAmtUnits,
                        percent:
                          parseFloat(item.reimbursement_amt) === 0
                            ? '0.00 %'
                            : parseFloat(
                                (parseFloat(
                                  item.rebate_amt -
                                    item.numOfRebateOffsetAmtUnits
                                ) / parseFloat(item.reimbursement_amt) || 0) *
                                  100
                              ).toFixed(2),
                      };
                    }) || []
                  : []
              }
              showSearchInfo
              enterMovesDown
              handleViewHistory={false}
              hideTotalCount={false}
              exportFile
              // isScrollOn
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              data-testid="onEditingStopped"
              fileName="RebateSummary"
              reportName="Rebate Percent of Spend Report"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              pinnedBottomRowData={pinnedBottomRowData}
              onFilterData={onFilterChanged}
              info={{ firstInfo, secondInfo, thirdInfo }}
              exportAllTpPDF={
                Object.keys(groupData).length > 1 ? exportAllTpPDF : null
              }
              getFilterApply={getFilterApply}
            />
          </div>
        </div>
      </div>
    </>
  );
}
